import { Card, CardHeader, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import Currency from "utils/currency";

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  },
  statsContainer: {
    display: 'flex'
  },
  statsItem: {
    padding: theme.spacing(3),
    flexGrow: 1,
    '&:first-of-type': {
      borderRight: `1px solid ${theme.palette.divider}`
    }
  },
}));


const WalletInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.wallet);

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Wallet Balance" />
      <Divider />
      <div className={classes.statsContainer}>
        <div className={classes.statsItem}>
          <Typography
            align="center"
            variant="h3"
          >
            {Currency.compress(model.balance)}
          </Typography>
          <Typography
            align="center"
            component="h4"
            gutterBottom
            variant="overline"
          >
            {model.currency}
          </Typography>
        </div>
      </div>
    </Card>
  );
};

WalletInfo.propTypes = {
  className: PropTypes.string,
};

export default WalletInfo;
